/* ==========================================================================
   Pahle Gratis-Aktion – Absicherung. Ergänzt pahle.js und wird direkt davor geladen
   (Einbindung: snippets/pahle-head.liquid).
   1. Die Kasse wartet, bis die Gratisartikel zum Warenkorb passen (schneller Klick auf „Zur Kasse“).
   2. Ein Verbindungsabbruch oder Seitenwechsel beim Hinzufügen sperrt die Zugabe nicht mehr.
   3. Eine Sperre (Shopify rechnet nicht kostenlos) gilt nur noch für genau diesen Warenkorb.
   Ersetzt dafür den Abgleich PahleGift.sync und die Kennung PahleGift.sig aus pahle.js – und zwar in dem
   Moment, in dem pahle.js sein Objekt als window.PahleGift bereitstellt (also noch vor dessen erstem Abgleich).
   Bei der nächsten Überarbeitung von pahle.js dort einarbeiten und diese Datei entfernen.
   ========================================================================== */
(function () {
  'use strict';

  // pahle.js schon geladen: sofort ergänzen. Sonst beim Bereitstellen von window.PahleGift.
  if (window.PahleGift) { patch(window.PahleGift); return; }
  var holder;
  try {
    Object.defineProperty(window, 'PahleGift', {
      configurable: true,
      get: function () { return holder; },
      set: function (v) { holder = v; try { patch(v); } catch (e) {} }
    });
  } catch (e) {}

  function patch(Gift) {
  var Cart = window.PahleCart;
  if (!Gift || !Cart || Gift.settle) return;
  var CFG = window.PAHLE || {};
  var ROUTES = CFG.routes || {};
  var root = (ROUTES.root || '/').replace(/\/?$/, '/');
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'Fehler');
          err.data = data; throw err;
        }
        return data;
      });
    });
  }

  // stable: true = letzter Abgleich abgeschlossen, keine Änderung unterwegs
  Gift.stable = !(Gift.busy || Gift.rechecked);
  Gift.runs = 0;
  Gift.waiters = [];

  // Kennung des Warenkorbs ohne die Gratisartikel (Positionen und Mengen)
  Gift.fp = function () {
    return $$('[data-p-cart] [data-p-line]').filter(function (l) { return !l.classList.contains('p-line--gift'); }).map(function (l) {
      return l.getAttribute('data-p-line') + ':' + $$('[data-qty]', l).map(function (b) { return b.getAttribute('data-qty'); }).join('.');
    }).join(',');
  };
  // Obergrenze für einen Warenkorb-Stand (Variante, Soll-Menge, Rabattcodes, Warenkorb), wenn Shopify weniger kostenlos rechnet.
  // Mit Rabattcode gilt sie unabhängig vom übrigen Warenkorb, sonst nur für genau diesen Warenkorb.
  Gift.sig = function (s) { return [s.variant, s.want, s.codes, s.codes ? '' : Gift.fp()].join('|'); };

  // Abgleich abgeschlossen: eine wartende Kasse darf weiter
  Gift.done = function () {
    Gift.stable = true;
    var list = Gift.waiters;
    Gift.waiters = [];
    list.forEach(function (fn) { fn(); });
  };
  // Drawer neu laden und abgleichen – auch dann, wenn das Neuladen scheitert oder nichts neu aufgebaut wird
  Gift.reload = function () {
    var seen = Gift.runs;
    return Cart.refresh().then(function () {
      setTimeout(function () { if (Gift.runs === seen) Gift.sync(); }, 0);
    });
  };
  // Vor der Kasse: warten, bis die Gratisartikel zum Warenkorb passen (höchstens 4 Sekunden).
  // fresh = vorher den aktuellen Stand vom Server holen (Warenkorbseite).
  Gift.settle = function (fresh) {
    return new Promise(function (resolve) {
      var finished = false, timer;
      function finish() { if (finished) return; finished = true; clearTimeout(timer); resolve(); }
      timer = setTimeout(finish, 4000);
      var running = Gift.busy || !Gift.stable;
      Gift.waiters.push(finish);
      if (running) return;
      if (!fresh) { Gift.done(); return; }
      Gift.stable = false;
      Gift.reload();
    });
  };

  function sync() {
    Gift.runs++;
    if (Gift.busy) return;
    var own = Gift.own;
    Gift.own = false;
    if (!own) Gift.chain = 0;
    var s = Gift.state();
    if (!s) { Gift.done(); return; }
    var live = Gift.live(s);
    var sig = Gift.sig(s);
    var cap = live ? Gift.cap(sig) : null;
    var want = live ? s.want : 0;
    if (cap !== null) want = Math.min(want, cap);

    // Sicherheitsnetz: Shopify rechnet die Gratisartikel nicht (alle) kostenlos
    // (Rabatt fehlt, anderer Bestellwert in Shopify, besserer Rabattcode). Erst nach einer zweiten Abfrage.
    if (live && !s.test && s.have > 0 && s.have <= want && !s.free) {
      if (!Gift.rechecked) { Gift.rechecked = true; Gift.stable = false; setTimeout(Gift.reload, 900); return; }
      cap = Math.max(0, Math.min(s.freeQty || 0, s.have));
      Gift.setCap(sig, cap);
      want = Math.min(want, cap);
    } else if (s.free || !s.have) {
      Gift.rechecked = false;
    }
    Gift.ui(s, live, cap === 0 && s.want > 0);

    var updates = {}, change = false, add = false;
    (s.stale || []).forEach(function (key) { updates[key] = 0; change = true; });
    if (want !== s.have) {
      if (s.lines && s.lines.length) {
        s.lines.forEach(function (l, i) { updates[l.key] = i === 0 ? want : 0; });
        change = true;
      } else if (want > 0 && !change) {
        add = true;
      }
    }
    if (!change && !add) { Gift.chain = 0; Gift.done(); return; }
    // Schutz vor Endlosschleifen: höchstens 3 automatische Änderungen hintereinander
    if (own && ++Gift.chain > 3) { Gift.done(); return; }

    Gift.busy = true;
    Gift.stable = false;
    var id = Cart.sectionId();
    var body = add
      ? { items: [{ id: s.variant, quantity: want, properties: { _pahle_gift: s.label || 'Gratis-Zugabe' } }] }
      : { updates: updates };
    if (id) { body.sections = id; body.sections_url = window.location.pathname; }
    var url = add
      ? (ROUTES.cartAdd ? ROUTES.cartAdd + '.js' : '/cart/add.js')
      : (ROUTES.cartUpdate || '/cart/update') + '.js';
    postJSON(url, body).then(function (data) {
      Gift.busy = false;
      Gift.own = true;
      if (id && data.sections && data.sections[id]) {
        var seen = Gift.runs;
        Cart.render(data.sections[id]);
        setTimeout(function () { if (Gift.runs === seen) Gift.sync(); }, 0);
      } else {
        Gift.reload();
      }
      // Warenkorbseite (Expanse-Formular) neu aufbauen, sonst ohne Wirkung
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function (err) {
      Gift.busy = false;
      // Nur wenn Shopify die Änderung ablehnt (z. B. nicht genug Bestand): für diesen Warenkorb-Stand nicht mehr versuchen.
      // Verbindungsabbruch oder Seitenwechsel: nichts merken, der nächste Abgleich versucht es erneut.
      if (err && err.data) Gift.setCap(sig, s.have);
      Gift.own = true;
      Gift.reload();
    });
  }
  // pahle.js ruft Gift.sync nach jeder Aktualisierung des Drawers auf. Ein Fehler darf die Kasse nicht aufhalten.
  Gift.sync = function () {
    try { sync(); } catch (e) { Gift.busy = false; Gift.done(); }
  };
  document.addEventListener('pahle:cart:updated', function () { Gift.stable = false; });

  // Vor der Kasse: erst weiter, wenn die Gratisartikel zum Warenkorb passen. Läuft vor der Prüfung in pahle.js
  // (Liefertermin), die beim erneuten Absenden unverändert greift.
  var going = false, pass = false;
  window.addEventListener('submit', function (e) {
    if (pass) return;
    var form = e.target, sub = e.submitter;
    if (!form || !form.querySelector) return;
    if (sub ? sub.name !== 'checkout' : !$('[name="checkout"]', form)) return;
    var inDrawer = !!form.closest('[data-p-cart]');
    var gs = Gift.state();
    if (!gs || !(Gift.live(gs) || gs.have > 0)) return;
    if (!Gift.busy && Gift.stable && inDrawer) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (going) return;
    going = true;
    setTimeout(function () { going = false; }, 8000);
    Gift.settle(!inDrawer).then(function () {
      going = false;
      // Der Drawer wurde inzwischen evtl. neu aufgebaut: dann das neue Formular absenden
      var target = form.isConnected ? form : null;
      if (!target) {
        var found = inDrawer ? $('[data-p-cart] form [name="checkout"]') : $$('form [name="checkout"]').filter(function (b) { return !b.closest('[data-p-cart]'); })[0];
        target = found ? found.form : null;
      }
      if (!target) { window.location.href = root + 'checkout'; return; }
      // Normal absenden (die Prüfungen aus pahle.js laufen mit); ältere Browser: direkt absenden
      var btn = $('[name="checkout"]', target);
      if (btn && target.requestSubmit) {
        var sent = false;
        pass = true;
        try { target.requestSubmit(btn); sent = true; } catch (err) {}
        pass = false;
        if (sent) return;
      }
      var input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = '';
      target.appendChild(input); target.submit();
    });
  }, true);
  }
})();